<datex-grid #$gridComponent *ngIf="initialized && !$hasMissingRequiredInParams" [selection]="true" (selectionChange)="$selectionChanged($event)" [headers]="headers" [rows]="rows" [(pageSize)]="pageSize" [(pageSkip)]="pageSkip" [totalCount]="totalCount" [loadingStatus]="loadingStatus" (pageChange)="$dataLoad()" [containerStyles]="containerStyles"
[canEdit]="canEdit"
[canAdd]="canAdd" [addNewRowFn]="addRow.bind(this)" [addLineModel]="bottomToolbar.addLine"

>
    <ng-container topToolbar>
    <div data-cy="tool-id-delete_selected_rows" *ngIf="!topToolbar.delete_selected_rows.hidden" class="toolContainer">
    <button mat-button
            data-cy="button"
            class="datex-button"
            [disabled]="topToolbar.delete_selected_rows.control.readOnly"
            [ngStyle]="topToolbar.delete_selected_rows.control.styles.style"
            [ngClass]="topToolbar.delete_selected_rows.control.styles.classes"
            (click)="on_delete_clicked($event)"
            >
      <div class="button-label">
        <ng-container *ngIf="topToolbar.delete_selected_rows.control.icon === 'datex-default-spinner'; else showIcon">
          <div class="button-icon">
            <i data-cy="button-icon" class="datex-default-spinner"></i>
          </div>
        </ng-container>
        <ng-template #showIcon>
          <div class="button-icon">
            <i data-cy="button-icon" class="icon {{topToolbar.delete_selected_rows.control.icon}}"></i>
          </div>
        </ng-template>
        <div data-cy="button-label" class="button-text">{{topToolbar.delete_selected_rows.control.label}}</div>
      </div>
    
    </button>
    </div>
  </ng-container>


  <ng-container gridColumnDef="name">

    <ng-template gridCellDisplayControlDef let-row>
    <Notifications-auto_email_report_options_dd_single 
        data-cy="selector"
        [type]="row.cells.name.displayControl.type"
        [formControl]="row.formGroup.controls['name_display']"
        (displayTextChange)="row.cells.name.displayControl.displayText=$event"
        [placeholder]="row.cells.name.displayControl.placeholder"
        [styles]="row.cells.name.displayControl.styles"
      [ruleContext]="row.$fields_name_selector_inParams_ruleContext"
      [excludeReports]="row.$fields_name_selector_inParams_excludeReports"
    >
    </Notifications-auto_email_report_options_dd_single>
    </ng-template>

    <ng-template gridCellEditControlDef let-row>
    <Notifications-auto_email_report_options_dd_single 
        data-cy="selector"
        [type]="row.cells.name.editControl.type"
        [formControl]="row.formGroup.controls['name_edit']"
        (displayTextChange)="row.cells.name.editControl.displayText=$event"
        [placeholder]="row.cells.name.editControl.placeholder"
        [styles]="row.cells.name.editControl.styles"
      [ruleContext]="row.$fields_name_selector_inParams_ruleContext"
      [excludeReports]="row.$fields_name_selector_inParams_excludeReports"
    >
    </Notifications-auto_email_report_options_dd_single>
    </ng-template>

  </ng-container>

<ng-container bottomToolbar>
</ng-container>


</datex-grid>
<div *ngIf="$hasMissingRequiredInParams" class="missing-params">
  <h3>Please provide {{$missingRequiredInParams.toString()}}</h3>
</div>
